import {
  useGetPatientBehaviourHistoryQuery,
  useGetPatientObservationsQuery,
} from '../../../repository';
import { GetPatientObservationsRequestDTO } from '../../../repository/dto/GetPatientObservationsRequestDTO';
import { useMemo } from 'react';
import { PatientObservationType } from '../../../value-object/PatientObservationType';

interface UseGetPatientObservationHistoryUseCaseParams {
  observationDescriptionId: string;
  familyRelationshipId?: string;
}

const useGetPatientBehaviourHistoryUseCase = (
  params: UseGetPatientObservationHistoryUseCaseParams,
) => {
  const { isLoading, data, error } = useGetPatientBehaviourHistoryQuery(params);

  return { data, isLoading, error };
};

export const useGetPatientBehaviourHistory = (
  params: Omit<GetPatientObservationsRequestDTO, 'type'>,
) => {
  const requestDTO: GetPatientObservationsRequestDTO = useMemo<GetPatientObservationsRequestDTO>(
    () => ({
      ...params,
      type: PatientObservationType.BEHAVIOURS,
    }),
    [params],
  );

  const { isLoading, data, error } = useGetPatientObservationsQuery(requestDTO);

  return { data, isLoading, error };
};

export default useGetPatientBehaviourHistoryUseCase;
